import config from '../config';
import { request } from '../utils/request';

const organizationDomain = `${config.host}${config.apiRouter.rioOrganization}`;
const regionOrganizationDomain = `${config.host}${config.apiRouter.regionOrganization}`;
const api = {
  // 创建机构 window.GLOBAL_VAR.global_switch.area_type === '0'
  createOrganization (data) {
    return request({
      method: 'POST',
      url: `${organizationDomain}/create?version=2018-12-18`,
      data,
    });
  },
  // 行政区划相关的创建机构 window.GLOBAL_VAR.global_switch.area_type === '1'
  regionCreateOrganization (data) {
    return request({
      method: 'POST',
      url: `${regionOrganizationDomain}CreateAgencyV1`,
      data,
    });
  },

  // 更新机构 window.GLOBAL_VAR.global_switch.area_type === '0'
  updateOrganization (data) {
    return request({
      method: 'POST',
      url: `${organizationDomain}/update?version=2018-12-18`,
      data,
    });
  },

  // 行政区划相关的更新机构 window.GLOBAL_VAR.global_switch.area_type === '1'
  regionUpdateOrganization (data) {
    return request({
      method: 'POST',
      url: `${regionOrganizationDomain}UpdateAgencyV1`,
      data,
    });
  },
  // 获取所有机构列表  window.GLOBAL_VAR.global_switch.area_type === '0'
  getOrganization (data) {
    const {
      offset = 0,
      limit = 10,
      name = '',
    } = data;
    return request({
      method: 'GET',
      url: `${organizationDomain}/list?version=2018-12-18&offset=${offset}&limit=${limit}&name=${name}`,
      data,
    });
  },
  // 获取所有机构列表 window.GLOBAL_VAR.global_switch.area_type === '1'
  ListAgencyInfoV1 (data) {
    return request({
      method: 'POST',
      url: `${regionOrganizationDomain}ListAgencyInfoV1`,
      data,
    });
  },
  // 查询行政区划
  getGdbsNav (data) {
    const { regCode } = data;
    return request({
      method: 'GET',
      url: `${config.host}${config.apiRouter.gdbsNav}?regCode=${regCode}`,
    });
  },
};
export default api;
